// [BD feat] Performance System — bd-performance-system.js
// Dev note: "change state while clicking on one of the 4x parts — just one dropdown can be open".
// State = active block (row open, image shown). The first block is open on load; only a click changes it.
// The scroll driver from the dev note ("While scrolling: change states") is gone (QA 2026-10-09, Figma
// comment #381): it opened the last row by default once the section was scrolled past, and the rows
// opening and closing under the reader made the page shift on mobile and desktop.
// No Figma Motion timeline exists for this section — TODO(motion-capture): swap the fade timing in
// bd-performance-system.css for the captured values when motion-specs.json lands.
// Client 2026-10-13: a click on the open row closes it again (no row open, the image stays), and the arrow
// turns to the right on the open row, like the FAQ.
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.bdPsBound) return;
    section.dataset.bdPsBound = '1';

    var triggers = [].slice.call(section.querySelectorAll('[data-bd-state-trigger]'));
    var frames = [].slice.call(section.querySelectorAll('[data-bd-state-image]'));
    var count = triggers.length;
    if (!count) return;

    var active = -1;

    // i = -1 closes every row; the image of the last open row stays
    function setActive(i) {
      i = i < 0 ? -1 : Math.min(count - 1, i);
      if (i === active) return;
      active = i;
      triggers.forEach(function (btn, idx) {
        var on = idx === i;
        btn.classList.toggle('is-active', on);
        btn.classList.toggle('bd-accordion-row--active', on);
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (panel) panel.hidden = !on;
      });
      if (i < 0) return;
      frames.forEach(function (frame) {
        frame.classList.toggle('is-active', parseInt(frame.dataset.bdStateImage, 10) === i);
      });
    }

    // Expose for the theme-editor block handler
    section.bdPerformanceSystem = { setActive: setActive };

    setActive(0);

    triggers.forEach(function (btn, idx) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(idx === active ? -1 : idx);
      });
    });
  }

  var section = document.querySelector('.bd-performance-system');
  if (!section) return;
  init(section);

  // Shopify theme editor: re-init on section load, follow the selected block.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('.bd-performance-system'));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('[data-bd-state]') : null;
    var host = item ? item.closest('.bd-performance-system') : null;
    if (!item || !host || !host.bdPerformanceSystem) return;
    host.bdPerformanceSystem.setActive(parseInt(item.dataset.bdState, 10));
  });
})();
// [BD feat] Performance System
